/**
 * TechnologyDomain CRUD
 */

import type { TechnologyDomain } from '../../graphql/types';
import { createEntityCrudClient } from './crudFactory';

export interface CreateTechnologyDomainInput {
  name: string;
  description?: string;
  tags?: string[];
  notes?: string;
}

export interface UpdateTechnologyDomainInput {
  name?: string;
  description?: string;
  tags?: string[];
  notes?: string;
}

const client = createEntityCrudClient<
  TechnologyDomain,
  CreateTechnologyDomainInput,
  UpdateTechnologyDomainInput
>('/technology-domains');

/**
 * Create a new technology domain
 */
export async function createTechnologyDomain(
  input: CreateTechnologyDomainInput
): Promise<TechnologyDomain> {
  return client.create(input);
}

/**
 * Update an existing technology domain
 */
export async function updateTechnologyDomain(
  technologyDomainId: string,
  input: UpdateTechnologyDomainInput
): Promise<TechnologyDomain> {
  return client.update(technologyDomainId, input);
}

/**
 * Delete a technology domain
 */
export async function deleteTechnologyDomain(
  technologyDomainId: string,
  hardDelete: boolean = false
): Promise<void> {
  return client.remove(technologyDomainId, hardDelete);
}
